import { BenchmarkingItemWithUnit } from '@/hooks'

export const getTopEntityIds = (
    data: BenchmarkingItemWithUnit[],
    count: number = 20
) => {
    const entitySet = new Map<number, string>()

    for (const item of data) {
        const { entityId, entityName } = item
        if (!entitySet.has(entityId)) {
            entitySet.set(entityId, entityName)
        }
    }

    let sortedEntities = [...entitySet.entries()].sort(
        ([_, nameA], [__, nameB]) => nameA.localeCompare(nameB)
    )

    if (count !== -1) {
        sortedEntities = sortedEntities.slice(0, count)
    }

    return sortedEntities.map(([id]) => id.toString())
}
